import 'jquery-deserialize';
import $ from 'jquery';

var queryStringToJSON = function(url) {
    if (url === '') return '';
    var pairs = (url || location.search).slice(1).split('&');
    var result = {};
    for (var idx in pairs) {
        var pair = pairs[idx].split('=');
        if (!!pair[0]) result[pair[0].toLowerCase()] = decodeURIComponent((pair[1] || '').replace(/\+/g, " "));
    }
    return result;
};

var load_records = function(params, append) {
    var form_params = $('#search-form').formSerialize();
    //$.History.go(form_params);

    history.pushState(null, null, '?' + form_params);
};

var load_persons = function(params) {
    $.ajax({
        url: '/cabinet/ajax/persons/' + params,
        type: 'GET',
        success: function(data, textStatus, jqXHR) {
            $('#u-persons-list').html(data);
        },
        error: function(jqXHR, textStatus, errorThrown) {
            alert('Произошла ошибка загрузки списка подходящих персон!');
        },
    });
};
var load_record_details = function(params) {
    if (params === '') {
        $('#u-record-details').html('');
        return;
    }

    $.ajax({
        url: '/cabinet/ajax/records/' + params + '/',
        type: 'GET',
        success: function(data, textStatus, jqXHR) {
            $('#u-record-details').html(data);
        },
        error: function(jqXHR, textStatus, errorThrown) {
            alert('Произошла ошибка загрузки детальной записи!');
        },
    });
};

$(function() {
    $('#u-records-list').on('click', 'td', function(e) {
        if ($(this).parent()[0].nodeName == 'THEAD') {
            e.preventDefault();
            return;
        }
        if (
            $(this)
                .parent()
                .is('.u-paginator')
        ) {
            return false;
        }

        if (!$(this).is('.u-records-control')) {
            //$('#u-records-list').find('tr').data('checked', 'false');
            $('#u-records-list')
                .find('td')
                .css({'background-color': 'white'});

            //$(this).data('checked', 'true');
            $(this)
                .parent('tr')
                .find('td[class!="u-records-control"]')
                .css({'background-color': 'grey'});
            $('#u-attach-button').data(
                'record-id',
                $(this)
                    .parent('tr')
                    .data('id')
            );

            load_persons(
                '?record_id=' +
                    $(this)
                        .parent('tr')
                        .data('id')
            );
            load_record_details(
                $(this)
                    .parent('tr')
                    .data('id')
            );
        }
    });

    $('#u-persons-list').on('click', 'td', function(e) {
        if ($(this).parent()[0].nodeName == 'THEAD') {
            e.preventDefault();
            return;
        }

        if (!$(this).is('.u-records-control')) {
            //$('#u-records-list').find('tr').data('checked', 'false');
            $('#u-persons-list')
                .find('td')
                .css({'background-color': 'white'});

            //$(this).data('checked', 'true');
            $(this)
                .parent('tr')
                .find('td[class!="u-records-control"]')
                .css({'background-color': 'grey'});

            $('#u-attach-button').data(
                'person-id',
                $(this)
                    .parent('tr')
                    .data('id')
            );
            $('#u-attach-controls').show();

            //load_persons('?record_id=' + $(this).data('id'))
        }
    });

    $('#u-records-list').on('click', '#u-attach-button', function(e) {
        var person_id = $(this).data('person-id');
        var record_id = $(this).data('record-id');

        if (!person_id || !record_id) {
            return false;
        }

        if (!confirm('Вы уверены, что хотите прикрепить выделенную запись к выделенной персоне?')) {
            return false;
        }

        $.ajax({
            url: '/cabinet/ajax/records/' + record_id + '/attach/',
            type: 'POST',
            data: {
                person_id: person_id,
            },
            success: function(data, textStatus, jqXHR) {
                load_records('');
                load_persons('');
                load_record_details('');
            },
            error: function(jqXHR, textStatus, errorThrown) {
                alert('Произошла ошибка прикрепления записи к персоне!');
            },
        });

        e.preventDefault();
    });

    $('#u-records-list').on('click', '.u-remove-record', function(e) {
        const $tr = $(this).parents('tr');
        var record_id = $tr.data('id');

        if (!confirm('Вы уверены, что хотите удалить запись?')) {
            return false;
        }

        $.ajax({
            url: '/cabinet/ajax/records/' + record_id + '/delete/',
            type: 'POST',
            success: function(data, textStatus, jqXHR) {
                $tr.remove();
            },
            error: function(jqXHR, textStatus, errorThrown) {
                alert('Произошла ошибка удаления записи!');
            },
        });

        e.preventDefault();
    });

    $('#u-records-list').on('click', '.u-favourite-record', function(e) {
        var $this = $(this);

        var $tr = $this.parents('tr');
        var record_id = $tr.data('id');

        $.ajax({
            url: '/cabinet/ajax/records/' + record_id + '/favourite/',
            type: 'POST',
            success: function(data, textStatus, jqXHR) {
                if (data['status'] == true) {
                    $this.html('<i title="Убрать из избранного">Избр.</i>');
                    $tr.children('td')
                        .eq(1)
                        .append(
                            '<i class="glyphicon glyphicon-star-empty u-in-fav" style="color: orange!important;"></i>'
                        );
                } else {
                    $this.html(
                        '<i class="glyphicon glyphicon-star" title="Добавить в избранное"></i>'
                    );
                    $tr.children('td')
                        .eq(1)
                        .find('.u-in-fav')
                        .remove();
                }
            },
            error: function(jqXHR, textStatus, errorThrown) {
                alert('Произошла ошибка избранного!');
            },
        });

        e.preventDefault();
    });

    $('#u-records-list').on('click', '.u-archive-record', function(e) {
        var $this = $(this);

        var $tr = $this.parents('tr');
        var record_id = $tr.data('id');

        $.ajax({
            url: '/cabinet/ajax/records/' + record_id + '/archive/',
            type: 'POST',
            success: function(data, textStatus, jqXHR) {
                if (data['status'] == true) {
                    $this.html('<i title="Убрать из архива">Неарх.</i>');
                    $tr.children('td')
                        .eq(1)
                        .append(
                            '<i class="u-in-archive glyphicon glyphicon-repeat" style="color: orange!important;"></i>'
                        );
                } else {
                    $this.html(
                        '<i class="glyphicon glyphicon-inbox" title="Добавить в архив"></i>'
                    );
                    $tr.children('td')
                        .eq(1)
                        .find('.u-in-archive')
                        .remove();
                }
            },
            error: function(jqXHR, textStatus, errorThrown) {
                alert('Произошла ошибка архива!');
            },
        });

        e.preventDefault();
    });

    $('#form-reset').click(function(e) {
        load_persons('');
        load_record_details('');
        $('#u-attach-button').data('person-id', '');
        $('#u-attach-button').data('record-id', '');

        e.preventDefault();
    });

    $('#u-records-filter').click(function(e) {
        load_records('');
        e.preventDefault();
    });

    var fill_in_form = (function() {
        $('#search-form').deserialize(queryStringToJSON());

        $('#u-records-filter').click();
    })();

    $('#u-records-list').on('click', '.u-create-person-from-record', function(e) {
        e.preventDefault();

        var href = $(this).attr('href');

        $.ajax({
            url: '/cabinet/ajax/records/' + $(this).data('record-id') + '/validate/',
            type: 'POST',
            success: function(data, textStatus, jqXHR) {
                if (data['is_valid'] === false) {
                    if (data['reason'] == 'rank') {
                        alert(
                            'В записи находится Сан, который отсутствует в базе. Пожалуйста, обратитесь к супервизору.'
                        );
                    } else {
                        alert('Произошла ошибка валидации, причина: ' + data['reason']);
                    }
                } else {
                    window.location.href = href;
                }
            },
            error: function(jqXHR, textStatus, errorThrown) {
                e.preventDefault();
                alert('Произошла ошибка валидации, обратитесь к системному администратору');
            },
        });
    });
});

export function Records() {
    if (!$('.u-records-page').length) {
        return;
    }

    $(function() {
        $('#u-records-list, #u-persons-list').on('click', '.tr-record-js', function(event) {
            var elem = $(this);

            $('.tr-record-js').removeClass('show-btns');
            elem.addClass('show-btns');
        });
    });
}
